const toolbarI18nDefaults = {
  'alignment.alignBottom': 'Align bottom',
  'alignment.alignCenter': 'Align center',
  'alignment.alignHorizontally': 'Align horizontally',
  'alignment.alignLeft': 'Align left',
  'alignment.alignRight': 'Align right',
  'alignment.alignTop': 'Align top',
  'alignment.alignVertically': 'Align vertically',
  'alignment.autoArrange': 'Auto arrange',
  'alignment.distributeHorizontally': 'Distribute horizontally',
  'alignment.distributeVertically': 'Distribute vertically',
  'alignment.resizeAndAlign': 'Resize & Align',
  'contextMenu.bringForward': 'Bring Forward',
  'contextMenu.bringToFront': 'Bring to Front',
  'contextMenu.copy': 'Copy',
  'contextMenu.createLinkedDoc': 'Create linked doc',
  'contextMenu.delete': 'Delete',
  'contextMenu.duplicate': 'Duplicate',
  'contextMenu.frameSection': 'Frame section',
  'contextMenu.groupSection': 'Group section',
  'contextMenu.reload': 'Reload',
  'contextMenu.rename': 'Rename',
  'contextMenu.sendBackward': 'Send Backward',
  'contextMenu.sendToBack': 'Send to Back',
  'contextMenu.turnIntoLinkedDoc': 'Turn into linked doc',
  'contextMenu.turnIntoCardView': 'Turn into card view',
  'contextMenu.ungroup': 'Ungroup',
  'toast.copiedToClipboard': 'Copied to clipboard',
  'toast.copyFailed': 'Failed to copy',
  'toast.fileNameEmpty': 'File name cannot be empty.',
  'toolbar.alignObjects': 'Align objects',
  'toolbar.align': 'Align',
  'toolbar.background': 'Background',
  'toolbar.backgroundColor': 'Background color',
  'toolbar.backgroundBlue': 'Blue background',
  'toolbar.backgroundDefault': 'Default background',
  'toolbar.backgroundGreen': 'Green background',
  'toolbar.backgroundGrey': 'Grey background',
  'toolbar.backgroundOrange': 'Orange background',
  'toolbar.backgroundPurple': 'Purple background',
  'toolbar.backgroundRed': 'Red background',
  'toolbar.backgroundTeal': 'Teal background',
  'toolbar.backgroundYellow': 'Yellow background',
  'toolbar.addText': 'Add text',
  'toolbar.cardView': 'Card view',
  'toolbar.caption': 'Caption',
  'toolbar.changeBackgroundColor': 'Change background color',
  'toolbar.changeIcon': 'Change icon',
  'toolbar.comment': 'Comment',
  'toolbar.codeBlock': 'Code Block',
  'toolbar.createLinkedDoc': 'Create linked doc',
  'toolbar.createTable': 'Create table',
  'toolbar.copyAsImage': 'Copy as Image',
  'toolbar.copyLink': 'Copy link',
  'toolbar.copyLinkToBlock': 'Copy link to block',
  'toolbar.copyOriginalLink': 'Copy original link',
  'toolbar.copyText': 'Copy text',
  'toolbar.download': 'Download',
  'toolbar.drawConnector': 'Draw connector',
  'toolbar.duplicateAsNote': 'Duplicate as note',
  'toolbar.duplicateAsNoteDescription':
    'Duplicate as note to create an editable copy, the original remains unchanged.',
  'toolbar.edit': 'Edit',
  'toolbar.embedView': 'Embed view',
  'toolbar.focusMedia': 'Show media',
  'toolbar.followMedia': 'Follow',
  'toolbar.followingMedia': 'Following',
  'toolbar.fullscreen': 'Fullscreen',
  'toolbar.automation': 'Automation',
  'toolbar.automationConnector': 'Connect automation',
  'toolbar.boxShadow': 'Box shadow',
  'toolbar.bulletedList': 'Bulleted List',
  'toolbar.connector': 'Connector',
  'toolbar.connectorCurve': 'Curve',
  'toolbar.connectorElbowed': 'Elbowed',
  'toolbar.connectorShape': 'Connector shape',
  'toolbar.connectorStraight': 'Straight',
  'toolbar.custom': 'Custom',
  'toolbar.database': 'Database',
  'toolbar.diamond': 'Diamond',
  'toolbar.divider': 'Divider',
  'toolbar.ellipse': 'Ellipse',
  'toolbar.eraser': 'Eraser',
  'toolbar.file': 'File',
  'toolbar.filmShadow': 'Film shadow',
  'toolbar.flipDirection': 'Flip direction',
  'toolbar.floatingShadow': 'Floating shadow',
  'toolbar.frame': 'Frame',
  'toolbar.general': 'General',
  'toolbar.group': 'Group',
  'toolbar.hand': 'Hand',
  'toolbar.heading1': 'Heading 1',
  'toolbar.heading2': 'Heading 2',
  'toolbar.heading3': 'Heading 3',
  'toolbar.heading4': 'Heading 4',
  'toolbar.heading5': 'Heading 5',
  'toolbar.heading6': 'Heading 6',
  'toolbar.highlighter': 'Highlighter',
  'toolbar.horizontalStyle': 'Horizontal style',
  'toolbar.image': 'Image',
  'toolbar.iconPicker': 'Icon picker',
  'toolbar.inlineView': 'Inline view',
  'toolbar.insertToPage': 'Insert to page',
  'toolbar.joinMedia': 'Join',
  'toolbar.largeHorizontalStyle': 'Large horizontal style',
  'toolbar.largeVerticalStyle': 'Large vertical style',
  'toolbar.layout': 'Layout',
  'toolbar.leaveMedia': 'Leave',
  'toolbar.left': 'Left',
  'toolbar.link': 'Link',
  'toolbar.lock': 'Lock',
  'toolbar.mediaMuted': 'Muted',
  'toolbar.mediaPaused': 'Paused',
  'toolbar.mindMap': 'Mind Map',
  'toolbar.more': 'More',
  'toolbar.moreMenu': 'More menu',
  'toolbar.moreTools': 'More Tools',
  'toolbar.mute': 'Mute',
  'toolbar.noShadow': 'No shadow',
  'toolbar.note': 'Note',
  'toolbar.numberedList': 'Numbered List',
  'toolbar.openThisDoc': 'Open this doc',
  'toolbar.original': 'Original',
  'toolbar.others': 'Others',
  'toolbar.pause': 'Pause',
  'toolbar.pen': 'Pen',
  'toolbar.pictureInPicture': 'Picture in Picture',
  'toolbar.polaroid': 'Polaroid',
  'toolbar.play': 'Play',
  'toolbar.playbackSpeed': 'Playback speed',
  'toolbar.paperShadow': 'Paper shadow',
  'toolbar.quote': 'Quote',
  'toolbar.radial': 'Radial',
  'toolbar.releaseFromGroup': 'Release from group',
  'toolbar.removeLink': 'Remove link',
  'toolbar.right': 'Right',
  'toolbar.roundedRectangle': 'Rounded rectangle',
  'toolbar.scribbled': 'Scribbled',
  'toolbar.select': 'Select',
  'toolbar.selectAndPan': 'Select (V) · Pan: middle mouse / Space',
  'toolbar.seek': 'Seek',
  'toolbar.shape': 'Shape',
  'toolbar.slide': 'Slide',
  'toolbar.smallHorizontalStyle': 'Small horizontal style',
  'toolbar.smallVerticalStyle': 'Small vertical style',
  'toolbar.soundOn': 'Sound on',
  'toolbar.square': 'Square',
  'toolbar.startPointStyle': 'Start point style',
  'toolbar.endPointStyle': 'End point style',
  'toolbar.stickerShadow': 'Sticker shadow',
  'toolbar.style': 'Style',
  'toolbar.switchView': 'Switch view',
  'toolbar.switchShapeType': 'Switch shape type',
  'toolbar.templates': 'Templates',
  'toolbar.text': 'Text',
  'toolbar.todoList': 'To-do List',
  'toolbar.turnInto': 'Turn into',
  'toolbar.triangle': 'Triangle',
  'toolbar.unlock': 'Click to unlock',
  'toolbar.unmute': 'Unmute',
  'toolbar.verticalStyle': 'Vertical style',
  'toolbar.volume': 'Volume',
  'toolbar.autoHeight': 'Auto height',
  'toolbar.contentAddedToPage': 'Content added to your page.',
  'toolbar.contentRemovedFromPage': 'Content removed from your page.',
  'toolbar.cuttingMode': 'Cutting mode',
  'toolbar.customizedHeight': 'Customized height',
  'toolbar.displayedInPage': 'Displayed in Page',
  'toolbar.displayedInPageTooltip':
    'This note is part of Page Mode. Click to remove it from the page.',
  'toolbar.displayInPage': 'Display in Page',
  'toolbar.findInToc': 'Find it in the TOC for quick navigation.',
  'toolbar.noteDisplayedInPageMode': 'Note displayed in Page Mode',
  'toolbar.noteRemovedFromPageMode': 'Note removed from Page Mode',
  'toolbar.size': 'Size',
  'toolbar.slicer': 'Slicer',
  'toolbar.viewInToc': 'View in Toc',
} as const;

export type EdgelessToolbarI18nKey = keyof typeof toolbarI18nDefaults;

export type EdgelessToolbarTranslator = (
  key: EdgelessToolbarI18nKey
) => string | undefined;

let toolbarTranslator: EdgelessToolbarTranslator | undefined;

export function registerEdgelessToolbarTranslator(
  translator: EdgelessToolbarTranslator
): void {
  toolbarTranslator = translator;
}

export function edgelessToolbarI18nT(key: EdgelessToolbarI18nKey): string {
  return toolbarTranslator?.(key) ?? toolbarI18nDefaults[key];
}
